import { render } from "./DeleteNoteModal.vue?vue&type=template&id=ef624320&scoped=true"
import script from "./DeleteNoteModal.vue?vue&type=script&lang=js"
export * from "./DeleteNoteModal.vue?vue&type=script&lang=js"

import "./DeleteNoteModal.vue?vue&type=style&index=0&id=ef624320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef624320"],['__file',"src/components/DeleteNoteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef624320"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef624320', __exports__)) {
    api.reload('ef624320', __exports__)
  }
  
  module.hot.accept("./DeleteNoteModal.vue?vue&type=template&id=ef624320&scoped=true", () => {
    api.rerender('ef624320', render)
  })

}


export default __exports__